import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class NullPointerException extends Exception {
}
NullPointerException.kind = 'NullPointerException';
export default NullPointerException;
